import { useEffect, useState } from 'react';

// HOOKS...
import useApi from '../../../../helpers/hooks/useApi';
import { useAuth } from '../../../../helpers/hooks/useAuth';

// COMPONENTS...
import { LayoutDashboardPanel } from '../../../../components/Layout/LayoutDashboard';
import { Table, TableHead, TableBody } from '../../../../components/Table/Table';
import { Badge } from '../../../../components/Badge/Badge';
import { DropdownButton, DropdownItemLink } from '../../../../components/Dropdown/Dropdown';
import { Alert } from '../../../../components/Alert/Alert';

// TYPES...
import { PruningTreeType } from '../../../../helpers/types/Types';

// STYLES...
import { Form } from '../../../../components/Form/FormStyled';

export function PruningTreeRead() {
    const host = window.location.href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, ``).split('/')[0];

    const api = useApi();
    const auth = useAuth();

    const token = auth.getToken();

    const [pruningTrees, setPruningTrees] = useState<PruningTreeType[]>([]);
    const [error, setError] = useState('');

    const [backendToken, setBackendToken] = useState(false);

    useEffect(() => {
        const verifyTokenBackend = async () => {
            const tk = await api.isMe(host, token);

            if (tk.token_active) {
                setBackendToken(true);
            } else {
                setBackendToken(false);
                auth.doLogout(); // Desloga no front...
                window.location.href = '/auth/client/login'; // Redireciona...
            }
        }
        verifyTokenBackend();
    }, []);

    const getPruningTrees = async () => {
        const pruning = await api.getPruningTrees(host, token);
        setPruningTrees(pruning.data);
    }

    useEffect(() => { getPruningTrees(); }, []);

    const handleStatus = async (uuid: string, status: number) => {
        const data = await api.setPruningTreeStatus(host, token, uuid, status);

        if (data.error) {
            setError(data.error);
        } else {
            getPruningTrees();
        }
    }

    return (
        token && backendToken
            ?
            <LayoutDashboardPanel
                id="dashboardPanel"
                title="Poda de árvores"
                description="Lista de podas solicitadas"
            >
                {error &&
                    <Alert
                        isError
                        closeAfter={7000}
                        title="Erro"
                        icon="code__errorCircle"
                        message={error}
                        state={error}
                        setState={setError}
                    />
                }

                <Table id="tableSectors">
                    <TableHead>
                        <tr>
                            <th scope="col"> # </th>
                            <th scope="col"> Código </th>
                            <th scope="col"> Nome </th>
                            <th scope="col"> Data </th>
                            <th scope="col"> Status </th>
                            <th scope="col"> Ações </th>
                        </tr>
                    </TableHead>

                    <TableBody>
                        {pruningTrees.map((pruningTree, index) => {
                            return (
                                <tr key={index}>
                                    <td> {pruningTree.id} </td>
                                    <td> {pruningTree.code} </td>
                                    <td> {pruningTree.name} </td>
                                    <td> {pruningTree.created_at} </td>
                                    <td>
                                        {(() => {
                                            if (pruningTree.status === 'Pendente') {
                                                return <Badge isWarning> {pruningTree.status} </Badge>

                                            } else if (pruningTree.status === 'Em andamento') {
                                                return <Badge isProcess> {pruningTree.status} </Badge>

                                            } else if (pruningTree.status === 'Concluída') {
                                                return <Badge isSuccess> {pruningTree.status} </Badge>

                                            } else if (pruningTree.status === 'Negada') {
                                                return <Badge isDanger> {pruningTree.status} </Badge>
                                            }
                                        })()}
                                    </td>
                                    <td className="td__action">
                                        <DropdownButton
                                            id={pruningTree.uuid}
                                            childrenId={pruningTree.uuid}
                                            name="Ações"
                                        >
                                            <DropdownItemLink
                                                link={`/panel/client/pruning-trees/show/${pruningTree.uuid}`}
                                                name="Detalhes"
                                                icon="general__visible"
                                            />

                                            {(pruningTree.status === 'Pendente' || pruningTree.status === 'Em andamento') &&
                                                <DropdownItemLink
                                                    link={`/panel/client/pruning-trees/reply/${pruningTree.uuid}`}
                                                    name="Responder"
                                                    icon="communication__chat5"
                                                />
                                            }

                                            <Form
                                                className="full__"
                                                onClick={() => handleStatus(pruningTree.uuid, 3)}
                                            >
                                                <DropdownItemLink
                                                    link=""
                                                    name="Concluir solicitação"
                                                    icon="navigation__check"
                                                />
                                            </Form>

                                            {/* <Form
                                                className="full__"
                                                onClick={() => handleStatus(pruningTree.uuid, 4)}
                                            >
                                                <DropdownItemLink
                                                    link=""
                                                    name="Negar solicitação"
                                                    icon="navigation__close"
                                                />
                                            </Form> */}
                                        </DropdownButton>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableBody>
                </Table>
            </LayoutDashboardPanel>
            : <></>
    );
}